import React from 'react';
import { Store, CircleCheck, Clock, Wallet, Banknote, ArrowUpRight } from 'lucide-react';
import { money } from '../lib/constants';

export const PartnerStats = ({ data, owner = false }) => {
  const stats = [
    ['Registered shops', data.totalRegistered, Store, 'registered'],
    ['Active referred shops', data.activeReferrals, CircleCheck, 'active'],
    ['Pending referrals', data.pendingReferrals, Clock, 'pending-referrals'],
    ['Commission earned', `€${money(data.totals.earned)}`, Banknote, 'earned'],
    ['Pending commission', `€${money(data.pendingCommission)}`, Clock, 'pending'],
    ['Available commission credit', `€${money(data.totals.available)}`, Wallet, 'available'],
    ['Approved payouts', `€${money(data.totals.reserved)}`, ArrowUpRight, 'approved'],
    ['Paid commission', `€${money(data.totals.paid)}`, Banknote, 'paid'],
  ];
  if (owner) stats.push(['Referred shop revenue', `€${money(data.grossRevenue)}`, Banknote, 'gross'], ['Revenue after commission', `€${money(data.netRevenue)}`, Banknote, 'net']);
  return <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">{stats.map(([label, value, Icon, key]) => <div key={key} className={`border-b py-4 ${owner ? 'border-slate-700' : 'border-slate-200'}`}>
    <div className="flex items-center gap-2 text-sm opacity-75"><Icon size={16} className="shrink-0" /><span className="min-w-0 break-words">{label}</span></div><p data-testid={`partner-stat-${key}`} className={`font-mono text-xl font-semibold mt-3 break-words ${owner ? 'text-emerald-400' : 'text-emerald-700'}`}>{value}</p>
  </div>)}</div>;
};